"use client";

import React from "react";

import Base from "@/templates/Base";

import Accordion from "@/components/shared/Accordion";

import styles from "./aniversario-cobasi.module.scss";

import faqData from "./mock";

export default function PageClient() {
  const handleTrackedClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
    const target = event.currentTarget;
    const dataTrack = target.getAttribute("data-track");
    const ctaText = target.getAttribute("cta-text");
    const ctaLocationClass = target.getAttribute("data-cta-location-class");

    typeof window !== "undefined" &&
      typeof window.gtag === "function" &&
      window.gtag("event", "click_cta_lp", {
        cta_text: ctaText,
        cta_location_class: ctaLocationClass,
        data_track: dataTrack
      });

    document.cookie = `lastSelectPromotionName=${dataTrack};path=/;domain=.${location.hostname.replace(/^www\./i, "")}`;
  };

  return (
    <Base>
      <main className={styles.main}>
        <section className={styles.banner}>
          <img
            className={styles.imgDesk}
            src="/inst/img/aniversario-cobasi/lp-aniversario-cobasi-2025-banner-principal-new.gif"
            alt="Texto inspire"
          />
          <img
            className={styles.imgMob}
            src="/inst/img/aniversario-cobasi/lp-aniversario-cobasi-2025-banner-principal-mobile-new.gif"
            alt="Texto inspire"
          />
        </section>

        <section className={`${styles.numero} dobra1_numerosdasorte`}>
          <div className={styles.container}>
            <div className={styles.title}>
              <h1 className="heading-lg">
                A Cobasi faz aniversário e o presente é seu:
                <br /> São mais de 40 chances de ganhar um ano de compras
                grátis!
              </h1>
              <p className="heading-sm">
                Cliente Amigo Cobasi abastece a rotina do pet, casa e jardim e
                ganha números da sorte para concorrer
              </p>
            </div>

            <div className={styles.content}>
              <div className={styles.wrapper}>
                <div className={styles.box}>
                  <h2 className="heading-lg">E tem mais</h2>
                  <h3 className="heading-sm">
                    Cliente Compra Programada ganha chance extra!
                  </h3>
                  <p className="heading-sm">
                    Saiba como participar comprando no site, APP Cobasi ou em
                    uma de nossas lojas físicas.
                  </p>
                  <a
                    className="btn btn-orange"
                    href="https://www.cobasi.com.br/compra-programada"
                    target="_blank"
                    data-track="lp-aniversario-cobasi_Cadastre"
                    cta-text="Compra Programada"
                    data-cta-location-class="dobra1_numerosdasorte"
                    onClick={handleTrackedClick}
                  >
                    Cadastre-se agora
                  </a>
                </div>

                <div>
                  <div className={styles.item}>
                    <img
                      src="/inst/img/aniversario-cobasi/lp-aniversario-cobasi-2025-cupom1.png"
                      alt="Imagem de cupom"
                    />
                    <div>
                      <h3 className="heading-lg">1 número</h3>
                      <p className="heading-sm">
                        para Cliente Amigo Cobasi,
                        <br />
                        nas compras a partir de R$ 149.
                      </p>
                    </div>
                  </div>
                  <span></span>
                  <div className={styles.item}>
                    <img
                      src="/inst/img/aniversario-cobasi/lp-aniversario-cobasi-2025-cupom2.png"
                      alt="Imagem de cupom"
                    />
                    <div>
                      <h3 className="heading-lg">2 números</h3>
                      <p className="heading-sm">
                        Para clientes com
                        <br />
                        Compra Programada ativa.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className={styles.atencao}>
                <p className="caption-md">
                  PROMOÇÃO EXCLUSIVA PARA CLIENTES CADASTRADOS NO PROGRAMA AMIGO
                  COBASI
                  <br /> 1. Válida para compras acima de R$ 149 realizadas em um
                  único documento fiscal, de 10/03 a 31/12/2025, exceto para a
                  compra de medicamentos 2. Os ganhadores receberão R$ 345/mês
                  por 12 meses, creditados em parcela única como pontos no
                  programada Amigo Cobasi, com validade de um ano. 3. Consulte
                  regulamento e certificado de autorização em
                  promocobasi40.com.br
                </p>
              </div>
            </div>
          </div>
        </section>

        <section className={`${styles.confira} dobra2_cadastro`}>
          <div className={styles.container}>
            <div className={styles.title}>
              <h3 className="heading-md">Confira como participar:</h3>
            </div>
            <div className={styles.content}>
              <div className={styles.item}>
                <img
                  src="/inst/img/aniversario-cobasi/lp-aniversario-cobasi-2025-cupom-fiscal-new.png"
                  alt="Imagem cupom fiscal"
                />
                <p className="subtitle-lg">
                  <strong>Guarde o cupom fiscal</strong>
                  <br />
                  das compras a partir de R$ 149
                </p>
              </div>
              <div className={styles.item}>
                <img
                  src="/inst/img/aniversario-cobasi/lp-aniversario-cobasi-2025-site-new.png"
                  alt="Acesse o site"
                />
                <p className="subtitle-lg">
                  <strong>Acesse o site</strong>
                  <br />
                  <a
                    href="//www.promocobasi40.com.br"
                    target="_blank"
                    data-track="lp-aniversario-cobasi_Acesse"
                    cta-text="Cadastre-se"
                    data-cta-location-class="dobra2_cadastro"
                    onClick={handleTrackedClick}
                  >
                    promocobasi40.com.br
                  </a>
                </p>
              </div>
              <div className={styles.item}>
                <img
                  src="/inst/img/aniversario-cobasi/lp-aniversario-cobasi-2025-cadastro-new.png"
                  alt="Imagem cadastro"
                />
                <p className="subtitle-lg">
                  <strong>Faça o cadastro</strong>
                  <br />
                  de acesso
                </p>
              </div>
              <div className={`${styles.item} ${styles.item4}`}>
                <img
                  src="/inst/img/aniversario-cobasi/lp-aniversario-cobasi-2025-cupom-fiscal2-new.png"
                  alt="Cadastro"
                />
                <p className="subtitle-lg">
                  <strong>Cadastre o cupom fiscal.</strong>
                  <br />É válido registrar quantos
                  <br /> cupons desejar!
                </p>
              </div>
            </div>
            <div className={styles.cadastre}>
              <a
                className="btn btn-orange"
                href="//www.promocobasi40.com.br"
                target="_blank"
                data-track="lp-aniversario-cobasi_Cadastre2"
                cta-text="Cadastre-se"
                data-cta-location-class="dobra2_cadastro"
                onClick={handleTrackedClick}
              >
                Cadastre-se agora
              </a>
            </div>
          </div>
        </section>

        <section className={`${styles.rotina} dobra3_ofertas `}>
          <div className={styles.container}>
            <div className={styles.content}>
              <div className={`${styles.wrapper} ${styles.info}`}>
                <img
                  className={styles.title}
                  src="/inst/img/aniversario-cobasi/lp-aniversario-cobasi-2025-banner-pet-precisa.png"
                  alt="Banner azul"
                />
              </div>
              <div className={styles.wrapper}>
                <img
                  src="/inst/img/aniversario-cobasi/lp-aniversario-cobasi-2025-cachorro-new.png"
                  alt="Banner azul"
                />
                <a
                  className="btn btn outlined btn-turquoise"
                  href="https://www.cobasi.com.br/pesquisa?hotsite=menu-promocao-cao"
                  target="_blank"
                  data-track="lp-aniversario-cobasi_Ofertas-cao"
                  cta-text="Ofertas Cão"
                  data-cta-location-class="dobra3_ofertas"
                  onClick={handleTrackedClick}
                >
                  Ofertas para seu cão
                </a>
              </div>
              <div className={`${styles.wrapper} ${styles.cat}`}>
                <img
                  src="/inst/img/aniversario-cobasi/lp-aniversario-cobasi-2025-gato-new.png"
                  alt="Banner azul"
                />
                <a
                  className="btn btn outlined btn-turquoise"
                  href="https://www.cobasi.com.br/pesquisa?hotsite=menu-promocao-gato"
                  target="_blank"
                  data-track="lp-aniversario-cobasi_Ofertas-gato"
                  cta-text="Ofertas Gato"
                  data-cta-location-class="dobra3_ofertas"
                  onClick={handleTrackedClick}
                >
                  Ofertas para seu gato
                </a>
              </div>
              <div className={`${styles.wrapper} ${styles.others}`}>
                <img
                  src="/inst/img/aniversario-cobasi/lp-aniversario-cobasi-2025-outros-animais-new.png"
                  alt="Banner azul"
                />
                <a
                  className="btn btn outlined btn-turquoise"
                  href="https://www.cobasi.com.br/pesquisa?hotsite=menu-promocao-outros-pets"
                  target="_blank"
                  data-track="lp-aniversario-cobasi_Ofertas-outros-pets"
                  cta-text="Ofertas Outros Pets"
                  data-cta-location-class="dobra3_ofertas"
                  onClick={handleTrackedClick}
                >
                  Ofertas para outros pets
                </a>
              </div>
            </div>
          </div>
        </section>

        {/* <section className={styles.produtos}>
          <div className={styles.container}>
            <div className={styles.title}>
              <h3>Confira as ofertas que separamos para você</h3>
            </div>
          </div>
        </section> */}

        <section className={styles.compre}>
          <div className={styles.content}>
            <div className={styles.photo}>
              <img
                src="/inst/img/aniversario-cobasi/lp-aniversario-cobasi-2025-cachorro-bolinha.png"
                alt="Imagem de cachorro com bolinha"
              />
            </div>
            <div>
              <p className="heading-xs">
                Há <strong>40 anos cuidamos do lado divertido do lar</strong>,
                são mais de 20 mil{" "}
                <strong>produtos para pet, casa e jardim</strong>, incluindo
                mais de 500 <strong>itens exclusivos de marcas próprias</strong>
                , como MyHug, Flicks, Origem Natural e Joy.
              </p>
              <div className={styles.box}>
                <h4 className="heading-xs">Compre onde preferir</h4>
                <div className={styles.photo}>
                  <div>
                    <img
                      src="/inst/img/aniversario-cobasi/lp-aniversario-cobasi-2025-photo-app.png"
                      alt="App"
                    />
                    <p className="subtitle-lg">APP</p>
                  </div>
                  <div>
                    <img
                      src="/inst/img/aniversario-cobasi/lp-aniversario-cobasi-2025-photo-site.png"
                      alt="Site"
                    />
                    <p className="subtitle-lg">Site</p>
                  </div>
                  <div>
                    <img
                      src="/inst/img/aniversario-cobasi/lp-aniversario-cobasi-2025-photo-loja.png"
                      alt="Loja"
                    />
                    <p className="subtitle-lg">Loja</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className={styles.faq}>
          <div className={styles.container}>
            <div className={styles.title}>
              <h3>Perguntas Frequentes</h3>
            </div>
            <div className={styles.faqList}>
              {faqData.map((item) => (
                <Accordion
                  key={item.id}
                  id={item.id}
                  title={item.question}
                  showAccordion={true}
                >
                  {Array.isArray(item.answer) ? (
                    <ul>
                      {item.answer.map((line, index) => (
                        <li
                          key={index}
                          dangerouslySetInnerHTML={{ __html: line }}
                        ></li>
                      ))}
                    </ul>
                  ) : (
                    <p dangerouslySetInnerHTML={{ __html: item.answer }}></p>
                  )}
                </Accordion>
              ))}
            </div>
          </div>
        </section>

        <section className={`${styles.regulamento} dobra6_regulamento `}>
          <div className={styles.container}>
            <div className={styles.content}>
              <a
                className="btn outlined btn-orange"
                href="/inst/img/aniversario-cobasi/regulamento-40-anos.pdf"
                target="_blank"
                data-track="lp-aniversario-cobasi_Regulamento"
                cta-text="Confira o regulamento"
                data-cta-location-class="dobra6_regulamento"
                onClick={handleTrackedClick}
              >
                Confira o regulamento completo
              </a>
            </div>
          </div>
        </section>
      </main>
    </Base>
  );
}
